import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { formatDate, formatToZMW, numberToWords, rootUrl, sumOfArray } from "../helpers";
import { useAuth } from "../context/auth-context";
import axios from "axios";
import { toast } from "react-toastify";

const PaymentVoucher = React.forwardRef(({ data }, ref) => {
  
  const {allData, setAllData} = useOutletContext();
  const auth = useAuth();
  const [voucherData, setVoucherData] = useState({
    preparedBy: {},
    checkedBy: {},
    authorisedBy: {},
    approvedBy: {},
    receivedBy: {},
    budgetDetails: [],
  });

  const {
    commitmentRefNo,
    cheque,
    voucher,
    paye,
    batchNo = "",
    journalNo = "",
    bSheetNo = "",
    date,
    purchaseOrderNo = "",
    chequeNumber = "",
    description,
    invoiceNumber = description?.split(':')[0]?.split('-')[1]?.trim(),
    amount,
    bank = "",
    accountNo = "",
    updatedBy,
  } = data;


  const [allneeded, setAllneeded] = useState([])

  const getSupData = async () => {

      try{
        const response = await axios.post(rootUrl(`/getInvoice`), {
          voucher:voucher,
          sid:paye
        });
       
        setAllneeded(response.data.data)
        
      }catch(e){
        toast.error(e?.message)
      }
  }
  
  
  const getOtherDetails = async () => {
    try {
      const response = await axios.get(rootUrl(`/getDetails/${data.id}`));
      const { other, actions } = response.data;
      const user = allData.users?.find((a) => a.u_id == updatedBy);
      const preparerName = `${user?.firstname || ""} ${user?.lastname || ""}`;
      
      const createSignerDetails = (actionIndex) => {
        const user = allData.users?.find(
          (a) => a.u_id === actions[actionIndex]?.uid
        );
        return {
          name: `${user?.firstname || ""} ${user?.lastname || ""}`,
          signature: "",
          date: actions[actionIndex]?.date,
        };
      };

      setVoucherData({
        preparedBy: {
          name: preparerName,
          signature: "",
          date: formatDate(date),
        },
        // checkedBy: createSignerDetails(0),
        // authorisedBy: createSignerDetails(1),
        // approvedBy: createSignerDetails(2),
        checkedBy: {
          name: '',
          signature: '',
          date: '',
        },
        authorisedBy: {
          name: '',
          signature: '',
          date: '',
        },
        approvedBy: {
          name: '',
          signature: '',
          date: '',
        },
        receivedBy: {
          name: other?.receivedByName || "",
          address: other?.address || "",
          signature: "",
          nrc: other?.nrc || "",
          date: other?.date || "",
          contactNo: other?.contactNo || "",
        },
        budgetDetails: allData.budget?.filter(
          (budget) => budget.id == data.coa_id
        ),
      });
    } catch (error) {
      console.error("Error fetching additional details:", error);
    }
  };

  useEffect(() => {
    getOtherDetails();
    getSupData();
  }, []);

  
  

  const renderBudgetDetails = () => {
    return (
      <table className="mt-0.5 border-collapse w-full text-xs">
        <tbody>
        <tr>
              <td colSpan={6} className="border border-gray-700 p-0.5">
                ACCOUNT NAME: <strong>{allData.bank.find(a=>a.id === bank)?.name}</strong>
              </td>
              <td colSpan={4} className="border border-gray-700 p-0.5">
                ACCOUNT NO: <strong>{allData.bank.find(a=>a.id === bank)?.account_no}</strong>
              </td>
            </tr>
            <tr>
              <th colSpan={10} className="border border-gray-700 text-center p-0.5">
                BUDGET ALLOCATION DETAILS
              </th>
            </tr>
            <tr>
              {['Head', 'Dept', 'Unit', 'Programme', 'Sub-Programme', 'Commitment Item', 'Item-Name', 'Account Code', 'K'].map((header) => (
                <th key={header} className="border border-gray-700 p-0.5 text-left text-xs">
                  {header}
                </th>
              ))}
            </tr>
          {allneeded.filter(a=>a.type == 'expense').map((row, index) => {
            const bItems = allData.budget?.filter(
              (budget) => budget.id == row.coa_id
            )[0]
            return(
              <tr key={index} className="text-center">
              <td className="border border-gray-700 p-0.5">{auth.user.cid}</td>
              <td className="border border-gray-700 p-0.5">{allData.dept.find(a=>a.id === bItems?.dept)?.name || "Finance"}</td>
              <td className="border border-gray-700 p-0.5">{bItems?.unit}</td>
              <td className="border border-gray-700 p-0.5">
                {allData.program?.find(
                  (a) => a.programCode === bItems?.program
                )?.name || ""}
              </td>
              <td className="border border-gray-700 p-0.5">
                {allData.subProgram?.find(
                  (a) => parseInt(a.subProgramCode) === parseInt(bItems?.subprogram) && parseFloat(a.programCode) === parseFloat(bItems.program)
                )?.name || ""}
              </td>
              <td className="border border-gray-700 p-0.5"></td>
              <td className="border border-gray-700 p-0.5">{allData.coa.find(a=>a.account == bItems?.coa)?.name || ""}</td>
              <td className="border border-gray-700 p-0.5">{bItems?.coa || ""}</td>
              <td className="border border-gray-700 p-0.5">
                {formatToZMW(row?.amount)}
              </td>
              
            </tr>
            )
          })}

          <tr>
            <th className="border border-gray-700 p-0.5" colSpan={8}>
              Total
            </th>
            <th className="border border-gray-700 p-0.5 text-center">
              {formatToZMW(sumOfArray(allneeded.filter(a=>a.type == 'expense').map(res=>parseFloat(res?.amount))))}
            </th>
          </tr>
        </tbody>
      </table>
    );
  };

  const renderSignerSection = (title, signer) => (
    <div className="border border-gray-700 p-0.5 text-xs">
      
      <p className="font-semibold text-xs">{title}</p>
      <p className="text-xs">Name: {signer?.name || ''}</p>
      <p className="text-xs">Signature: {signer?.signature || ''}</p>
      <p className="text-xs">Date: {signer?.date || ''}</p>
      <p className="text-xs">Designation: </p>
    </div>
  );

  return (
    <div
      ref={ref}
      className=""
    >

{/* Header Section */}
<table className="w-full">
          <tbody>
            <tr>
              <td className="border-none">
              <img src="arms.png" className="w-[100px] h-[100px]" alt="Logo" />
              </td>
              <td className="border-none text-center" colSpan={6}>
                <h3 className=" font-bold">
                  <span className="text-lg">REPUBLIC OF ZAMBIA</span> <br />
                  <span className="text-base">MINISTRY OF LOCAL GOVERNMENT</span>
                  <br />
                  <span className="text-base">{allData.council[0]?.name.toUpperCase()}</span>
                </h3>
                <u className="text-base font-bold">PAYMENT VOUCHER</u>
              </td>
              <td className="border-none">
              <img className="w-[100px] h-[100px]" src={rootUrl(`/${allData?.council[0]?.path}`)} alt="Council Logo" />
              </td>
            </tr>
          </tbody>
        </table>


      {/* Payment Details Section */}

      <div className="grid grid-cols-2 gap-1 items-center text-xs">
        <div>
        <p className="text-xs"><strong>COMMITMENT REF NO:</strong> {commitmentRefNo}</p>
        <p className="text-xs"><strong>PAYMENT VOUCHER NO:</strong> {voucher}</p>
        </div>

        <div>
        <h2 className="text-center font-bold text-xs">BATCH HEADER DETAILS</h2>
      {/* Batch Number */}
      <div className="flex">
        <span className="font-semibold text-xs w-24">BATCH NO.</span>
        <span className="border-b border-black flex-1 text-xs">{data.batchNo}</span>
      </div>
        </div>
      </div>
    
        <div className="mt-0.5 flex gap-2 items-center">
        <div className="w-[40%]">
            <p className="border border-gray-400 text-sm font-semibold  p-1 pb-[15%]">
              <strong>PAYEE:</strong> 
              <br />  
              {allData.suppliers?.find((a) => a.id == paye)?.name || allData.bank?.find((a) => a.id == allneeded.find(a=>a.type == 'income')?.bank)?.name}
            </p>
          </div>
  
  
          <div className="w-[60%]">
          <div className="max-w-2xl mx-auto  bg-white">
      

      <div className="border border-gray-400 p-0.5 text-xs">

      {/* Journal No. & B/Sheet No. */}
         
         <div className="flex w-full">
         <div className="w-1/2 items-center">
        <span className="font-semibold text-xs w-1/4">JOURNAL NO.:</span>
        <div className="flex space-x-0.5">
        {["","","",""].map((char, index) => (
        <div
          key={index}
          className="w-2.5 h-2.5 border border-black flex items-center justify-center text-xs p-1"
        >
          {char}
        </div>
      ))}

        </div>
      </div>
  
      <div className="w-1/2 items-center">
        <span className="font-semibold text-xs w-1/4">B/SHEET NO.:</span>
        <div className="flex space-x-0.5">
        {["","",""].map((char, index) => (
        <div
          key={index}
          className="w-2.5 h-2.5 border border-black flex items-center justify-center text-xs  p-1"
        >
          {char}
        </div>
      ))}

        </div>
      </div>
      </div>

      {/* Other Details */}
      <div className=" flex items-center">
        <span className="font-semibold text-xs w-[40%] w-1/4">Date:</span>
        <div className="flex space-x-0.5 mt-0.5">
        {`${date.substring(8,10)}/${date.substring(5,7)}/${date.substring(0,4)}`?.split("").map((char, index) => (
  <div
    key={index}
    className="w-2.5 h-2.5 border border-black flex items-center justify-center  text-xs p-1"
  >
    {char}
  </div>
))}

        </div>
      </div>

      <div className=" flex items-center">
        <span className="font-semibold text-xs w-[40%] w-1/4">Purchase Order No:</span>
        <span className="border-b border-black ml-1 px-10 text-xs">{purchaseOrderNo}</span>
      </div>

      <div className=" flex items-center">
        <span className="font-semibold text-xs w-[40%] w-1/4">Invoice Number:</span>
        <span className={`border-b border-black ml-1 text-xs ${invoiceNumber == '' || invoiceNumber == undefined?'px-10':''}`}>{invoiceNumber}</span>
      </div>

      {/* Cheque/EFTA Number */}
      <div className="flex items-center">
        <span className="font-semibold text-xs w-[40%]">Cheque/EFTA Number:</span>
        <div className="flex space-x-0.5 mt-0.5">
          {cheque?.split("").map((char, index) => (
            <div
              key={index}
              className="w-2.5 h-2.5 border border-black flex items-center justify-center text-xs p-1"
            >
              {char}
            </div>
          ))}
        </div>
      </div>
    </div>
    </div>
          </div>
        </div>
      
        
       

     {/* Description Section */}
        <div className="mt-0.5">
          <p className="text-xs"><strong>DESCRIPTION OF PAYMENT</strong></p>
          <div className="h-6 border-t border-b border-gray-700 p-1 text-xs">
            {description}
          </div>
          
          <p className="mt-0.5 text-xs"><strong>AMOUNT IN WORDS</strong></p>
          <div className="h-6 border-t border-b border-gray-700 p-1 text-xs">
          {numberToWords(sumOfArray(allneeded.filter(a=>a.type == 'expense').map(res=>parseFloat(res.amount))))} Kwacha
          </div>
        </div>

    

    


      {renderBudgetDetails()}
      {/* Signatures */}
      <div className="grid grid-cols-2 gap-2 mb-0.5 text-xs mt-0.5">
        {renderSignerSection("PREPARED BY", voucherData.preparedBy)}
        {renderSignerSection("CHECKED BY", voucherData.checkedBy)}
        {renderSignerSection("AUTHORISED BY", voucherData.authorisedBy)}
        {renderSignerSection("APPROVED BY", voucherData.approvedBy)}
      </div>

      {/* Received By */}
      <div className="border border-gray-700 text-xs p-0.5">
      <p className="font-semibold text-xs">RECEIVED BY</p>
        <div className="grid grid-cols-2 gap-2">

        <div>
        <p className="text-xs">Name: {voucherData.receivedBy.name}</p>
        <p className="text-xs">Address: {voucherData.receivedBy.address}</p>
        <p className="text-xs">Signature: {voucherData.receivedBy.signature}</p>
        </div>

        <div> 
        <p className="text-xs">NRC No.: {voucherData.receivedBy.nrc}</p>
        <p className="text-xs">Date.: {voucherData.receivedBy.date}</p>
        <p className="text-xs">Contact No.: {voucherData.receivedBy.contactNo}</p>
        </div>
        
       
      </div>
      </div>

      <p className="text-[10px] mt-0.5">NOTE: EFTA = ELECTRONIC FUNDS TRANSFER ADVICE</p>
    </div>
  );
});

export default PaymentVoucher;
